/* eslint-disable max-len */
import React from 'react';


const CrownIcon: React.FC = () => {
	return (
		<svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1 2.88235L5.25 7.54545L9.5 1L13.75 7.54545L18 2.88235V16.0588H9.5H1V2.88235Z" fill="#001B74" fillOpacity="0.7" stroke="#001B74" stroke-linejoin="round"/>
		</svg>
	);
}

export default CrownIcon;